// utils/axios.js
import axios from 'axios';
import { BASE_URL } from '../constants';

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // Always send cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor for debugging
axiosInstance.interceptors.request.use(
  (config) => {
    // Let the browser set multipart boundary (manual Content-Type breaks file uploads)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    // Log request in development
    if (import.meta.env.DEV) {
      console.log('🔍 Axios Request:', {
        method: config.method,
        url: config.url,
        baseURL: config.baseURL,
        withCredentials: config.withCredentials,
      });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 errors globally
    if (error.response && error.response.status === 401) {
      console.error('🔍 401 Unauthorized - Cookie may be missing or invalid');
      // Optionally redirect to login
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

